<template>
	<div>
		<div v-if="show==true" class="gray">
			<div class="dialog">
				<div style="display:inline-block; width:100%;">
					<p class="title">Upload Invoice</p>
					<p class="cancel" v-on:click="cancel()"><font-awesome-icon icon="times" /></p>
				</div>
				<hr/>
				<div style="display:inline-block; width:100%;">
					<b-form-file
						class="upload-box text-nowrap text-truncate"
						size="lg"
						accept="application/pdf"
						v-model="uploadFile"
						placeholder="Choose or Drop file here"
						drop-placeholder="Drop file here"
						@input="select()"
					></b-form-file>
					<div class="uploading-box" v-bind:class="{ hidden: !loading }">
						<div v-bind:id="'loading-progress'" class="uploading-bar-green"></div>
					</div>

					<div style="display:inline-block; width:100%;">
						<p style="float:left; width:100px; margin-bottom:0px;">Invoice ID</p>
						<input v-on:input="inputNumber($event, 'invoiceId')" v-model="invoiceId" style="float:left; width:100px;"></input>
					</div>
					<div style="display:inline-block; width:100%;">
						<p style="float:left; width:100px; margin-bottom:0px;">Amount</p>
						<input v-on:input="inputNumber($event, 'amount')" v-model="amount" style="float:left; width:100px;"></input>
					</div>
				</div>
				<hr/>
				<div style="display:inline-block; width:100%;">
					<button class="buttons" v-on:click="save()" :disabled="!ready">Upload</button>
					<button class="buttons" v-on:click="cancel()">Cancel</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
import {PAGES} from './../../constants.js'
export default {
    props: {
		show: {
			type: Boolean,
			required:false,
			default:true,
		},
    },
	data() {
		return {
			pageid:PAGES.ADD_INVOICE_PAGE,
			invoiceId:'',
			amount:'',

			uploadFile:null,
			file:null,

			loading:false,
			ready:false,
			loadingBar:null,
		}
	},
	async created () {

	},
	methods: {
		inputNumber(event, vModel) {
			this[vModel] = event.target.value.replace(/[^0-9.]/g, '')
		},
		async select() {
			this.file=null;
			this.loading=true;
			this.ready=false;
			this.loadingBar.style = "width:0%"

			if(this.uploadFile!=null){
				new Promise((resolve, reject) => {
					var reader = new FileReader()
					reader.onload = function(e){
						this.file = e.target.result
						resolve(null);
					}.bind(this);

					reader.onprogress = function(e){
						if (e.lengthComputable) {
			                var progress = parseInt( ((e.loaded / e.total) * 100), 10 );
							this.loadingBar.style = "width:"+progress+"%"
			            }
					}.bind(this);

					reader.onerror = function(e){
						alert("error: File could not be read")
						reject(null);
					}.bind(this);

					reader.readAsDataURL(this.uploadFile)
		        }).then((res) => {
					this.loadingBar.style = "width:100%"
					this.ready=true;
				})
			}
		},
		async save() {
			api.postDataImage(
				{
					data:{
						pageid:this.pageid,
						file:this.file,
						invoiceId:this.invoiceId,
						amount:this.amount,
					}
				}
			).then((res) => {

				this.invoiceId = ''
				this.amount = ''
				this.uploadFile = null
				this.file = null

				alert(res.data.message)
			}).finally((res) => {
				this.loading = false
				this.ready = false
				this.loadingBar.style = "width:0%"

				this.cancel();
			})
		},
		async cancel() {
			this.$emit('cancel');
		},
	},
	watch:{
		show(){
			this.$nextTick(function () {
				if(this.show) {
					this.invoiceId = ''
					this.amount = ''
					this.uploadFile = null
					this.file = null
					this.loading = false
					this.ready = false
					this.loadingBar = document.getElementById("loading-progress")
					this.loadingBar.style = "width:0%"
				}
			})
		},
	}
}
</script>

<style scoped>

.dialog{
	position:fixed;
	background-color:white;
	left: 50%;
	top:20vh;
	min-width:500px;
	transform: translateX(-50%);
	padding:15px;
	border:1px solid black;
	border-radius: 5px;
	box-shadow: 2px 2px;
}

.title{
	font-size: 40px;
	font-weight: bold;
	float:left;
	margin:0px;
}

.cancel{
	float:right;
	width:30px;
	text-align: center;
	font-size:24px;
}
.cancel:hover{
	color:#5c5e70;
}

.paragraph{
	font-size:22px;
	margin:0px;
	white-space: pre-wrap;
}

.buttons{
	float:right;
	font-size:18px;
}

.gray {
	display: absolute;
	position: fixed;
	z-index: 2;
	padding-top: 100px;
	left: 0;
	top: 0;
	width:100%;
	height:100%;
	overflow:auto;
	background-color: rgba(0,0,0,0.5);
}

.textfield{
    width:100%;
	height:150px;
	min-height:75px;
	max-height:375px;
}

.uploading-box{
	background-color: #c2c2c2;
	border-radius: 20px;
	padding:3px;
	width:100%;
	height:10px;
	margin-bottom:10px;
}
.uploading-bar{
	background-color: #2696ed;
	border-radius: 20px;
	height:100%;
	transition:width .5s ease-in-out;
}
.uploading-bar-green{
	background-color: #1cff42;
	border-radius: 10px;
	height:100%;
	transition:width .5s ease-in-out;
}

</style>



// WEBPACK FOOTER //
// src/layouts/upload_invoice.vue